import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=d4217048&scoped=true"
import script from "./EventDialog.vue?vue&type=script&lang=js"
export * from "./EventDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDialog.vue?vue&type=style&index=0&id=d4217048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4217048",
  null
  
)

export default component.exports